var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NewslettersSignupStepLayout',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }